import React from 'react';
import './ClassroomEnhanced.css';

const SideQuestPanel = ({ quests = [], onCompleteQuest, user }) => {
  const empty = !quests || quests.length === 0;

  return (
    <section className="sidequest-panel">
      <div className="section-heading">
        <div>
          <p className="eyebrow">Bonus fun</p>
          <h3>Side quests just for you</h3>
        </div>
      </div>

      {empty ? (
        <p className="sidequest-empty">No side quests right now. Ask your coach for an extra challenge! 🎮</p>
      ) : (
        <div className="sidequest-grid">
          {quests.map((quest) => (
            <article key={quest.id} className={`sidequest-card ${quest.status}`}>
              <div className="sidequest-header">
                <h4>{quest.title}</h4>
                <span className="quest-status">{quest.status}</span>
              </div>
              <p>{quest.description}</p>
              <div className="sidequest-meta">
                <span>Reward: ⭐ {quest.reward || 5}</span>
                <span>
                  {quest.updatedAt?.toDate?.()?.toLocaleDateString?.() || quest.createdAt?.toDate?.()?.toLocaleDateString?.()}
                </span>
              </div>
              {quest.status === 'available' && (
                <button
                  type="button"
                  className="cta primary"
                  onClick={() => onCompleteQuest?.(quest.id, quest.reward)}
                >
                  Claim reward
                </button>
              )}
              {quest.status === 'completed' && (
                <p className="sidequest-complete">🎉 Completed! Enjoy your points.</p>
              )}
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default SideQuestPanel;
